import { render, staticRenderFns } from "./DeletionModal.vue?vue&type=template&id=3bd89c6c&scoped=true"
import script from "./DeletionModal.vue?vue&type=script&lang=js"
export * from "./DeletionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd89c6c",
  null
  
)

export default component.exports